export function reducer(state, action) {
  switch (action.type) {
    case 'set_loading':
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload
        }
      }
    case 'set_show_assets': {
      //console.log('setting assets:', action.payload)
      return {
        ...state,
        showAssets: action.payload
      }
    }
    case 'restore_state': {
      console.log('Restoring state:', action.payload)
      return {
        ...state, // Keep existing state values
        ...action.payload // Overwrite with cached values
      }
    }
    case 'reset_state': {
      console.log('Resetting state:', action.payload)
      return action.payload // Reset to initial state
    }
    case 'set_documents': {
      return { ...state, documents: action.payload }
    }
    case 'pop_selected_category': {
      let result = state.selectedCategories.slice(0, -1)

      return {
        ...state,
        selectedCategories: result
      }
    }
    case 'append_selected_category': {
      let result = state.selectedCategories.concat([action.payload])

      return {
        ...state,
        selectedCategories: result
      }
    }
    case 'reset_selected_category': {
      return {
        ...state,
        selectedCategories: [],
        showAssets: false
      }
    }
    case 'set_navigation': {
      return {
        ...state,
        navigation: action.payload
      }
    }
    case 'set_assets': {
      return {
        ...state,
        assets: action.payload
      }
    }
    case 'append_assets': {
      let fullAssets = state.publishedAssets.concat(action.payload)
      return {
        ...state,
        assets: fullAssets
      }
    }
    case 'set_raw_assets': {
      return {
        ...state,
        rawAssets: action.payload
      }
    }
    case 'append_raw_assets': {
      let fullAssets = { ...state.rawAssets, ...action.payload }
      return {
        ...state,
        rawAssets: fullAssets
      }
    }
    case 'set_signed_assets': {
      return {
        ...state,
        signedAssets: action.payload
      }
    }
    case 'append_signed_assets': {
      let fullAssets = { ...state.signedAssets, ...action.payload }
      return {
        ...state,
        signedAssets: fullAssets
      }
    }
    case 'set_published_assets': {
      return {
        ...state,
        publishedAssets: action.payload
      }
    }
    case 'append_published_assets': {
      let fullAssets = { ...state.publishedAssets, ...action.payload }
      return {
        ...state,
        publishedAssets: fullAssets
      }
    }
    case 'remove_asset': {
      const assetId = action.payload
      const newRaw = { ...state.rawAssets }
      const newSigned = { ...state.signedAssets }
      const newPublished = { ...state.publishedAssets }
      delete newRaw[assetId]
      delete newSigned[assetId]
      delete newPublished[assetId]
      return {
        ...state,
        rawAssets: newRaw,
        signedAssets: newSigned,
        publishedAssets: newPublished
      }
    }
    case 'set_modal_active': {
      return {
        ...state,
        modalActive: action.payload
      }
    }
    case 'set_modal_status': {
      return {
        ...state,
        modalStatus: action.payload
      }
    }
    case 'set_modal_data': {
      const newCurrentAsset =
        action.payload?.assetId || action.payload?.asset?.id

      const newState = {
        ...state,
        modalData: action.payload,
        currentAsset: newCurrentAsset
      }
      return newState
    }
    case 'add_tag': {
      let newAssets = [...state.publishedAssets]
      newAssets[action.payload.currentIdx].tags = action.payload.newTags

      return {
        ...state,
        assets: newAssets
      }
    }
    case 'remove_tag': {
      let newAssets = [...state.publishedAssets]
      newAssets[action.payload.currentIdx].tags = action.payload.newTags

      return {
        ...state,
        assets: newAssets
      }
    }
    default: {
      console.log('Reducer received unknown action:', action.type, action)
    }
  }
  console.log('Reducer about to throw error for unknown action:', action.type)
  throw Error('Unknown action:' + action.type)
}
